import { useState } from 'react';
import './LoginPage.css';
import { login } from '../../api/authAPI/authAPI.js';
import useLang from '../../hooks/use-lang/useLang.js';

export default function LoginPage({ onLogin }) {
  const { t } = useLang();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const canSubmit = username.length > 0 && password.length > 0 && !loading;

  async function handleSubmit(event) {
    event.preventDefault();
    if (!canSubmit) return;

    setLoading(true);
    setError(null);

    try {
      await login(username.trim(), password.trim());
      onLogin?.();
    } catch (err) {
      const message = err.message === 'INVALID_CREDENTIALS'
        ? t('login.errInvalid')
        : err.message === 'MISSING_CREDENTIALS'
          ? t('login.errMissing')
          : err.message === 'Failed to fetch'
            ? t('login.errServer')
            : err.message === 'UNAUTHORIZED'
              ? t('login.errSession')
              : t('login.errGeneric');
      setError(message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <main className="login-page">
      <form className="login-form" onSubmit={handleSubmit}>
        <div className="title__container">
          <h1 className="login-title">
            {t('login.welcome')}
            <span className="tochka__load__admin">
              <span className="loading-dot" />
              <span className="loading-dot" />
              <span className="loading-dot" />
            </span>
          </h1>
        </div>

        {error && <p className="login-error">{error}</p>}

        <div className="form-group">
          <label className="form-label" htmlFor="username">{t('login.username')}</label>
          <input
            id="username"
            type="text"
            className={error ? 'form-input form-input--error' : 'form-input'}
            value={username}
            onChange={(event) => { setUsername(event.target.value); if (error) setError(null); }}
            placeholder={t('login.username')}
            autoComplete="username"
            required
          />
        </div>

        <div className="form-group">
          <label className="form-label" htmlFor="password">{t('login.password')}</label>
          <input
            id="password"
            type="password"
            className={error ? 'form-input form-input--error' : 'form-input'}
            value={password}
            onChange={(event) => { setPassword(event.target.value); if (error) setError(null); }}
            placeholder={t('login.password')}
            autoComplete="current-password"
            required
          />
        </div>

        <button className="login-button" type="submit" disabled={!canSubmit}>
          {loading ? t('login.signingIn') : t('login.signIn')}
        </button>
      </form>
    </main>
  );
}
